// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"plot_wrapper__1AarP","plot":"plot_plot__Dz2jl"};